<div class="noteMain" [ngClass]="{'Half': !UIType, 'Full': UIType}">
  <div [ngClass]="{'half': !UIType, 'full': UIType}">
    <nz-divider nzOrientation="left" nzText="Description"></nz-divider>
    <div class="description-area" [ngClass]="{'scrolled': UIType}">
      <div class="description-content" [innerHTML]="desc"></div>
    </div>
  </div>

  <div [ngClass]="{'half': !UIType, 'full': UIType}">
    <nz-divider nzOrientation="left" nzText="Work Notes"></nz-divider>

    <div #projectCommentsContainer class="comments-scroll scrolled">
      <div *ngIf="!commentDataList?.length" class="no-comments-msg">
        No notes yet. Be the first to add one.
      </div>

      <div *ngFor="let comment of commentDataList" class="chat-row" [class.is-me]="isCurrentUser(comment.created_by)">
        <nz-avatar *ngIf="!isCurrentUser(comment.created_by)" nzSize="small" nzIcon="user"
          [nzSrc]="getBase64Image(comment.created_by_image)" class="chat-avatar"></nz-avatar>

        <div class="chat-bubble-wrap">
          <span class="chat-author" *ngIf="!isCurrentUser(comment.created_by)">{{ comment.created_by_name }}</span>
          <div class="chat-bubble" [innerHTML]="comment.comment"></div>
          <div class="chat-meta-row">
            <span class="chat-time">{{ comment.created_at | date:'MMM d, h:mm a' }}</span>
            <button *ngIf="canEditComment(comment)" class="comment-edit-btn" nz-button nzType="link" nzSize="small" (click)="startEditComment(comment)" title="Edit">
              <span nz-icon nzType="edit"></span>
            </button>
          </div>
        </div>

        <nz-avatar *ngIf="isCurrentUser(comment.created_by)" nzSize="small" nzIcon="user"
          [nzSrc]="getBase64Image(comment.created_by_image)" class="chat-avatar"></nz-avatar>
      </div>
    </div>

    <div class="comment-input-wrapper" [ngClass]="{'comment-input-wrapper-half': !UIType}">
      <div *ngIf="editingComment" class="edit-mode-banner">
        <span nz-icon nzType="edit" style="margin-right:5px;"></span>
        Editing comment
        <button nz-button nzType="link" nzSize="small" class="cancel-edit-link" (click)="cancelEditComment()">Cancel</button>
      </div>
      <quill-editor theme="snow" placeholder="Type a message... use &#64; to mention someone" class="editor"
        [modules]="quillConfig" [(ngModel)]="messageInput"></quill-editor>
      <div class="comment-actions">
        <span class="comment-hint">
          <nz-icon nzType="info-circle" nzTheme="outline"></nz-icon>
          Type <kbd>&#64;</kbd> to mention someone
        </span>
        <button class="post-comment-btn" nz-button nzType="primary" [disabled]="!messageInput" (click)="sendMessage()">
          <nz-icon [nzType]="editingComment ? 'save' : 'send'" nzTheme="outline"></nz-icon>
          {{ editingComment ? 'Update' : 'Send' }}
        </button>
      </div>
    </div>
  </div>
</div>